import React from 'react'

import T from 'components/FormattedMessage'
import Button from 'components/Button'
import config from 'config'

import AutoSubIntro from './components/AutoSubIntro'
import AutoSubBase from './components/AutoSubBase'

type Props = React.ComponentProps<typeof AutoSubBase> & {
  isAcknowledged?: boolean
  isActivated?: boolean
  onStoreClick: () => void
  ackAutosubIntro: () => void
}

type State = {
  introOpen: boolean
}

class AutoSub extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props)
    this.state = {
      introOpen: false,
    }
  }

  onIntroOpen = () => {
    this.setState({ introOpen: true })
  }

  onIntroClose = () => {
    this.setState({ introOpen: false })
    this.props.ackAutosubIntro()
  }

  onStoreClick = () => {
    this.props.onStoreClick()
    this.props.ackAutosubIntro()
  }

  render() {
    const { isAcknowledged, ...props } = this.props

    if (!isAcknowledged && !config.IS_STORE_DISABLED) {
      return (
        <>
          <AutoSubBase
            {...props}
            rightChild={(
              <Button fullWidth size="small" color="secondary" variant="contained" onClick={this.onIntroOpen}>
                <T id="autosub_action_learnmore" />
              </Button>
            )}
            message={<T id="autosub_message_available" />}
          />
          <AutoSubIntro
            open={this.state.introOpen}
            onStoreClick={this.onStoreClick}
            onClose={this.onIntroClose}
          />
        </>
      )
    }

    if (props.isActivated) {
      return <AutoSubBase {...props} message={<T id="autosub_message_active" />} />
    }

    return <AutoSubBase {...props} />
  }
}

export default AutoSub
